"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Card = ({ title, dataAttribute, description, image, onClick }) => {
    return (react_1.default.createElement("button", { style: { backgroundColor: `${image.bgColor}` }, className: "\n                w-full h-full m-0\n                md:m-8 flex md:h-[25vw]\n                md:max-h-[22rem] md:min-h-[12rem] md:w-[25vw] md:min-w-[12rem]\n                md:max-w-[22rem] flex-col items-center justify-center md:rounded-lg bg-cyan-500\n                text-white md:shadow md:shadow-slate-400 transition-all\n                hover:cursor-pointer md:hover:shadow-xl hover:bg-cyan-700", "data-category": dataAttribute, onClick: onClick },
        react_1.default.createElement("div", { className: "w-2/3 h-1/3 fill-white flex justify-center items-center maskedSVG", style: {
                maskImage: `url(${image.path})`,
                WebkitMaskImage: `url(${image.path})`,
                backgroundColor: `${image.color}`,
            } }),
        react_1.default.createElement("span", { className: "mt-8" }, title),
        react_1.default.createElement("p", null, description)));
};
exports.default = Card;
